/** Mirrors brian's `normalize_e164` (modules/phone/numbers.py): NANP-only; anything ambiguous is refused. */

const E164 = /^\+[1-9]\d{7,14}$/;
const NANP_LEADING = /^[2-9]/;

const digitsOf = (value: string): string => value.replace(/\D/g, "");

export const toDestinationE164 = (typed: string): string | null => {
  const stripped = typed.replace(/[\s().-]/g, "");
  if (stripped.startsWith("+")) return E164.test(stripped) ? stripped : null;
  if (!/^\d+$/.test(stripped)) return null;
  if (stripped.length === 10 && NANP_LEADING.test(stripped))
    return `+1${stripped}`;
  if (
    stripped.length === 11 &&
    stripped[0] === "1" &&
    NANP_LEADING.test(stripped[1])
  )
    return `+${stripped}`;
  return null;
};

const groupNanp = (digits: string): string => {
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
};

/** A "+" number stays ungrouped: a foreign grouping would be a guess. */
export const formatDialInput = (typed: string): string => {
  if (typed.trim().startsWith("+")) return `+${digitsOf(typed)}`;
  const digits = digitsOf(typed);
  if (digits.length === 11 && digits[0] === "1")
    return `1 ${groupNanp(digits.slice(1))}`;
  if (digits.length <= 10) return groupNanp(digits);
  return digits;
};
